var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "image-uploader" },
    [
      _c(
        "button",
        {
          staticClass: "btn-upload",
          on: {
            click: function($event) {
              _vm.showModal = !_vm.showModal
            }
          }
        },
        [_vm._v("\n    Upload Image\n  ")]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "preview-list w-100" },
        _vm._l(_vm.previews, function(img, index) {
          return _c(
            "div",
            { key: index, staticClass: "position-relative image-preview" },
            [
              _c("img", {
                staticClass: "preview",
                attrs: { title: "Lihat Gambar Produk", src: img },
                on: {
                  click: function($event) {
                    return _vm.openImage(img)
                  }
                }
              }),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "remove-image",
                  on: {
                    click: function($event) {
                      return _vm.remove(index)
                    }
                  }
                },
                [_vm._v("×")]
              )
            ]
          )
        }),
        0
      ),
      _vm._v(" "),
      _vm.showModal
        ? _c("upload-modal", {
            attrs: { value: _vm.value, limit: _vm.limit },
            on: { input: _vm.updateValue, close: _vm.closeModal }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ef56bd88", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ef56bd88","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/monitoring/links/imageUpload/index.vue
// module id = null
// module chunks = 